import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Empty } from "antd";

import {
  inputFields,
  Spacer,
  boxContainer,
  GetProPopup,
} from "../../components";

import { Images } from "../../config";

const VisaInformation = () => {
  const { visaInfo } = useSelector((state) => state?.others);
  const { questionnaire } = useSelector((state) => state?.questionnaire);
  const profileData = useSelector((state) => state?.profile?.user);

  const [countryList, setCountryList] = useState([]);
  const [visaInformation, setVisaInformation] = useState(null);
  const [countryId, setCountryId] = useState(null);

  useEffect(() => {
    const filteredCountries = visaInfo?.map((country) => ({
      label: country.name,
      value: country.id,
    }));
    setCountryList(filteredCountries);
  }, [visaInfo]);

  useEffect(() => {
    visaInfo?.map((visaInfo) => {
      if (visaInfo.id === countryId) {
        setVisaInformation(visaInfo.visaInfos);
      }
    });
  }, [countryId]);

  useEffect(() => {
    visaInfo?.map((visaInfo) => {
      if (questionnaire?.countryPreference?.length > 0) {
        if (visaInfo.name === questionnaire?.countryPreference[0]) {
          setCountryId(visaInfo.id);
        }
      } else {
        if (visaInfo.name === profileData?.country) {
          setCountryId(visaInfo.id);
        }
      }
    });
  }, [profileData, visaInfo, questionnaire]);

  const generalInfo = [
    {
      icon: Images.VisaInfoCostOfApp,
      title: "Cost of Application",
      subTitle: "ONE TIME",
      value: visaInformation?.costOfVisaApp ?? "NA",
      hoverTitle:
        "Indicates the one-time fee required to apply for and obtain the student visa.",
    },
    {
      icon: Images.VisaInfoMedical,
      title: "Medical Fees",
      subTitle: "PER YEAR",
      value: visaInformation?.medicalFees ?? "NA",
      hoverTitle:
        "Indicates the annual fee for medical coverage as part of the student visa process, if applicable.",
    },
    {
      icon: Images.VisaInfoDuration,
      title: "Duration of Visa",
      value: visaInformation?.visaDuration ?? "NA",
      hoverTitle:
        "Indicates to the length of time the student visa remains valid after issuance.",
    },
    {
      icon: Images.VisaInfoProcessing,
      title: "Visa Processing Time",
      value: visaInformation?.visaProcessingTime ?? "NA",
      hoverTitle:
        "Indicates the typical duration it takes for the visa to be processed and approved after submission.",
    },
  ];

  return (
    <div className="text-black relative">
      {profileData?.freeUser && (
        <div className="absolute top-[100px] left-[35%] z-[10]">
          <GetProPopup />
        </div>
      )}
      <div className={`${profileData?.freeUser && "blur pointer-events-none"}`}>
        <div
          className="university-hero-section h-[22.5em] flex items-end"
          style={{
            backgroundImage: `url(${
              visaInformation?.countryPicture ?? Images?.VisaInfoCoverDefault
            })`,
          }}
        >
          <div className="flex gap-3 items-center py-6 px-7 w-full bg-gradient-to-t from-[#000000] rounded-b-2xl">
            <div className="text-[1.125em] font-semibold text-white">
              Select Country
            </div>
            <div className="w-[300px]">
              <inputFields.SelectDropdown
                items={countryList}
                onChange={(e) => setCountryId(e)}
                value={countryId}
              />
            </div>
          </div>
        </div>

        <div className="p-2">
          <Spacer height={20} />
          {visaInformation ? (
            <>
              <div className="grid grid-cols-3 gap-3">
                <div className="col-span-2 flex flex-col gap-2">
                  <div className="box-title">General Information</div>
                  <boxContainer.LiteBoxContainer addstyle="h-full">
                    <div className="flex justify-around items-center h-[10em]">
                      {generalInfo?.map((item, index) => (
                        <div
                          className="flex flex-col gap-2 items-center justify-center"
                          key={index}
                          title={item?.hoverTitle}
                        >
                          <img src={item?.icon} className="h-[3.75em]" />
                          <div className="box-content-title pb-2 border-b-[2px] border-b-gray-300 w-full text-center">
                            {item.title} <br />
                            <div className="text-[0.625em] text-main w-full text-center h-[0.75em]">
                              {item.subTitle}
                            </div>
                          </div>
                          <div className="box-content-value">{item.value}</div>
                        </div>
                      ))}
                    </div>
                  </boxContainer.LiteBoxContainer>
                </div>
                <div className="col-span-1 flex flex-col gap-2 ">
                  <div className="box-title">Additional Information</div>
                  <boxContainer.LiteBoxContainer addstyle="h-full">
                    <div className="h-[10em] overflow-auto font-medium text-justify">
                      {visaInformation?.visaDescription ?? <Empty />}
                    </div>
                  </boxContainer.LiteBoxContainer>
                </div>
              </div>
              <Spacer height={30} />
              <div className="grid grid-cols-3 gap-3">
                {visaInformation?.documentsRequired?.length > 0 && (
                  <div className="col-span-1 flex flex-col gap-2">
                    <div className="box-title">Documents Required</div>
                    <boxContainer.LiteBoxContainer addstyle="h-full">
                      <div className="flex flex-col gap-2 max-h-[25em] overflow-auto pr-1">
                        {visaInformation?.documentsRequired?.map(
                          (item, index) => (
                            <div
                              className="h-full font-medium flex w-full gap-2"
                              key={index}
                            >
                              <div>
                                <div className="h-3 w-3 rounded-full bg-main mt-1"></div>
                              </div>
                              <div className="text-justify">
                                {item?.document}
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    </boxContainer.LiteBoxContainer>
                  </div>
                )}
                {visaInformation?.healthInsurance?.title &&
                  visaInformation?.healthInsurance?.description &&
                  visaInformation?.healthInsurance?.cost && (
                    <div className="col-span-1 flex flex-col gap-2 ">
                      <div className="box-title">Health Insurance</div>
                      <boxContainer.LiteBoxContainer addstyle="h-full">
                        <div className="flex flex-col gap-2 max-h-[25em] overflow-auto pr-1">
                          <div className="font-bold">
                            {visaInformation?.healthInsurance?.title}
                          </div>
                          <div>
                            <b>Cost:</b>{" "}
                            {visaInformation?.healthInsurance?.cost}
                          </div>
                          <div>
                            <b>Description:</b>{" "}
                            {visaInformation?.healthInsurance?.description}
                          </div>
                        </div>
                      </boxContainer.LiteBoxContainer>
                    </div>
                  )}
                {visaInformation?.pointsToNote?.length > 0 && (
                  <div className="col-span-1 flex flex-col gap-2 ">
                    <div className="box-title">Points to Note</div>
                    <boxContainer.LiteBoxContainer addstyle="h-full">
                      <div className="flex flex-col gap-2 max-h-[25em] overflow-auto pr-1">
                        {visaInformation?.pointsToNote?.map((item, index) => (
                          <div
                            className="h-full font-medium flex w-full gap-2"
                            key={index}
                          >
                            <div>
                              <div className="h-3 w-3 rounded-full bg-main mt-1"></div>
                            </div>
                            <div className="text-justify">{item?.point}</div>
                          </div>
                        ))}
                      </div>
                    </boxContainer.LiteBoxContainer>
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="text-[1.75em] text-main text-center font-bold p-4">
              Please Select a Country to View Visa Information Details!
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VisaInformation;
